import React from 'react'
import ConvoFlow from './convo_flow'
import IonIcon from '@reacticons/ionicons'

const ConversationFlowTab = ({ limitedPermission }) => {
  const accessRestricted =
    limitedPermission?.bot_customize_upload_bot_image === false &&
    limitedPermission?.bot_customize_upload_bot_launcher_image === false

  return (
    <div className='flex flex-col space-y-3 mb-5 w-full'>
      {accessRestricted ? (
        <div className='text-center px-4 py-6 bg-white/60 backdrop-blur-md max-w-[500px] rounded-xl shadow-[0_4px_12px_0_rgba(0,0,0,0.15)]'>
          <IonIcon
            name='lock-closed-outline'
            className='text-[24px] mb-2 text-[#7C50DD]'
          />
          <h2 className='text-xl font-semibold mb-2'>Access Restricted</h2>
          <p className='text-sm text-gray-700 mb-4'>
            Upgrade your plan to customize your bot's conversation flow. Unlock advanced control
            over interactions and responses.
          </p>
          <a href='/subscription'>
            <button className='bg-[#7C50DD] rounded-full font-medium text-[12px] px-6 py-2 text-white cursor-pointer shadow hover:shadow-lg transition-all duration-200'>
              Upgrade Now
            </button>
          </a>
        </div>
      ) : (
        <ConvoFlow />
      )}
    </div>
  )
}

export default ConversationFlowTab
